import type { CfoGlDetailQueryState } from './cfoGlDetailQuery'
import type { CurrentGlScope } from './CfoCurrentGlDetail'

/**
 * One-shot handoff of a GL query scope between CFO pages (e.g. the Financials
 * GL-detail drilldown → the full GL detail explorer). The shell's nav routing
 * carries only a nav id, so the pending scope rides in module state and is
 * cleared once the explorer applies it.
 */
export type CfoGlDetailHandoff = Pick<
  CfoGlDetailQueryState,
  'search' | 'startDate' | 'endDate' | 'filters' | 'scopes'
> & {
  originWorkbookId?: string | null
  nativeScope?: CurrentGlScope
  label?: string
}

let pending: CfoGlDetailHandoff | null = null

export function setPendingCfoGlDetailHandoff(next: CfoGlDetailHandoff): void {
  pending = next
}

// Peek + clear are separate so the consumer can clear only after a successful
// apply (StrictMode double-runs the mount effect and cancels the first pass).
export function peekPendingCfoGlDetailHandoff(): CfoGlDetailHandoff | null {
  return pending
}

export function clearPendingCfoGlDetailHandoff(): void {
  pending = null
}
